import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth } from "./components";
import { AppLayout } from "./layouts/AppLayout";
import { HomePage, LoginPage, SalesAnalyticsPage } from "./pages";

export const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="sales-analytics" element={<SalesAnalyticsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
